<template>
  <div class="home-container">
    <div class="home-content">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          @click="back"
          style="width: 90px"
          >返回</el-button
        >
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="topicName" label="问题名称" align="center">
        </el-table-column>           
        <el-table-column prop="answerName" label="答案" align="center">
        </el-table-column>           
        <el-table-column prop="createTime" label="提交时间" align="center">
        </el-table-column>      
      </el-table>
      <!-- 分页器
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import reg from '../../utils/reg'
export default {
    props:{
     objId:Object,
     questionnaireId: Number,   
    },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      addData: {
        id: "",
        name:''
      },
      addDataRules: {
        name: [{ required: true, message: "请输入问题名称", trigger: "blur" }],
      },      
      isShowloading:false,
      isAddModal:false,
      btnLoading:false,
      modalTitle:""
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 返回活动列表
    back(){
        this.$emit('answerBack',true)
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },  
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },     
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    onLoad() {
      console.log(this.objId)
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        questionnaireId:this.questionnaireId,
        userId:this.objId.userId,
      }
      this.$Apis.questionnaireDetail(data).then(res=>{
        if (res.code == 200) {
          // let { current, list, pages, total } = res.data;
          // this.currentPage = current;
          // this.size = pages;
          // this.total = total;
          this.tableData = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>